/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
// @mui material components
import {
  Card,
  Snackbar,
  Alert,
  TextField,
  Backdrop,
  CircularProgress,
} from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import VpnKeyOffIcon from "@mui/icons-material/VpnKeyOff";
// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { API_ROUTES } from "utils/constants";
import { axiosInstance } from "../../../../axios";
import Icon from "@mui/material/Icon";
// Images
import bgImage from "assets/images/bg-reset-cover.jpg";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import { APP_URL } from "utils/constants";

function Cover() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({
    email: "",
  });
  const setAlert = useSetRecoilState(AlertState);
  const handleChange = (event) => {
    setEmail(event.target.value);
  };
  async function onSubmitForm(event) {
    event.preventDefault();
    if (email.length == 0) {
      setErrors({
        ...errors,
        email: "Địa chỉ Email không được trống",
      });
      return;
    }
    if (validateEmail(email)) {
      setErrors({
        ...errors,
        email: "Địa chỉ Email không đúng định dạng",
      });
      return;
    }
    try {
      setLoading(true);
      let data = {
        email: email,
        domain: APP_URL,
      };
      const response = await axiosInstance.post("password_reset", data);
      setAlert({
        alert: true,
        message: "Gởi mail thành công!",
        type: "success",
      });
      setLoading(false);
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
      console.log(error);
      setLoading(false);
      return;
    }
  }
  return (
    <CoverLayout coverHeight="50vh" image={bgImage}>
      <Card>
        {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress color="info" />
            </MDBox>
          </Backdrop>
        )}
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Reset Password
          </MDTypography>
        </MDBox>
        <MDBox pb={3} px={3} pt={2}>
          <MDBox component="form" role="form">
            <MDBox mb={4}>
              <TextField
                required
                type="email"
                label="Email"
                name="email"
                onChange={handleChange}
                value={email}
                variant="standard"
                fullWidth
                error={errors ? !!errors.email : false}
                helperText={errors?.email}
                onFocus={() => {
                  setErrors({
                    ...errors,
                    email: "",
                  });
                }}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                type="submit"
                variant="gradient"
                color="info"
                fullWidth
                onClick={onSubmitForm}
                startIcon={<VpnKeyOffIcon />}
              >
                reset
              </MDButton>
            </MDBox>
            <MDTypography display="block" variant="button" my={1} mt={2}>
              Hệ thống sẽ gởi thông tin xác nhận vào Email của bạn trong vòng 60
              giây.
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

const validateEmail = (value) => {
  var pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );
  let check = false;
  if (!pattern.test(value)) {
    check = true;
  }
  return check;
};

export default Cover;
